import { UpdateIllustrationIcon } from '@weblite/icons'
import { InstallTwaLayout } from '$common/install-twa-layout'
import { t } from '$i18n'

export function RecommendInstallTwa({ isOpen }: { isOpen: boolean }) {
  return (
    <InstallTwaLayout
      isOpen={isOpen}
      icon={
        <UpdateIllustrationIcon
          sx={{ width: '240px', height: '180px', margin: 'auto' }}
        />
      }
      title={t('installTwa.recommend.title')}
      description={t('installTwa.recommend.description')}
    />
  )
}
